import { Coordinate, TileSize } from "game-common/models"

/** Invert the same vertical lift used to render the selected building layer. */
export const buildingPlaneTarget = (world: Coordinate, yOffset = 0): Coordinate => ({
    x: Math.floor(world.x / TileSize),
    y: Math.floor((world.y - yOffset) / TileSize),
})
